import { render, staticRenderFns } from "./DjVueAcSelect.vue?vue&type=template&id=27d54aeb&"
import script from "./DjVueAcSelect.vue?vue&type=script&lang=ts&"
export * from "./DjVueAcSelect.vue?vue&type=script&lang=ts&"
import style0 from "./DjVueAcSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports